export default function WhyBook() {
    const benefits = [
        {
            title: "Exclusive Deals",
            description: "Get access to exclusive hotel deals and discounts.",
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.7}
                    stroke="currentColor"
                    className="h-7 w-7"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.847-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.847a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.847.813a4.5 4.5 0 0 0-3.09 3.09Z"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M18.259 8.715 18 9.75l-.259-1.035a2.25 2.25 0 0 0-1.65-1.65L15.056 6.75l1.035-.259a2.25 2.25 0 0 0 1.65-1.65L18 3.75l.259 1.091a2.25 2.25 0 0 0 1.65 1.65l1.035.259-1.035.259a2.25 2.25 0 0 0-1.65 1.706Z"
                    />
                </svg>
            ),
        },
        {
            title: "Wide Selection",
            description: "Choose from 1000+ hotels across Dubai.",
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.7}
                    stroke="currentColor"
                    className="h-7 w-7"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3.75 21h16.5M4.5 21V9.75A1.5 1.5 0 0 1 6 8.25h3A1.5 1.5 0 0 1 10.5 9.75V21m3 0V4.5A1.5 1.5 0 0 1 15 3h3a1.5 1.5 0 0 1 1.5 1.5V21"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M7 12h.01M7 15h.01M7 18h.01M16 7h.01M16 10h.01M16 13h.01M16 16h.01M16 19h.01"
                    />
                </svg>
            ),
        },
        {
            title: "Trusted Reviews",
            description: "Real reviews from real guests you can trust.",
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.7}
                    stroke="currentColor"
                    className="h-7 w-7"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6.633 10.25c.806 0 1.533-.446 1.902-1.17l.612-1.2c.423-.83 1.266-1.35 2.197-1.35h.905c.828 0 1.5.672 1.5 1.5v.75h2.168c1.38 0 2.5 1.12 2.5 2.5v.75c0 3.728-3.022 6.75-6.75 6.75H8.25a3 3 0 0 1-3-3v-5.53c0-.276.224-.5.5-.5h.883Z"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M14.25 8.78V6.75a2.25 2.25 0 0 0-2.25-2.25h-.75"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4.5 10.25v6.75"
                    />
                </svg>
            ),
        },
        {
            title: "24/7 Support",
            description: "Our team is available around the clock.",
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.7}
                    stroke="currentColor"
                    className="h-7 w-7"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M8.25 11.25V9a3.75 3.75 0 0 1 7.5 0v2.25M6 18.75a3 3 0 0 1-3-3v-3a3 3 0 0 1 3-3h.75v6H6ZM18 18.75a3 3 0 0 0 3-3v-3a3 3 0 0 0-3-3h-.75v6H18Z"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M8.25 18.75h1.5a2.25 2.25 0 0 0 2.25-2.25v-.75"
                    />
                </svg>
            ),
        },
        {
            title: "Flexible Payments",
            description: "Multiple payment options for your convenience.",
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.7}
                    stroke="currentColor"
                    className="h-7 w-7"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M2.25 8.25h19.5M4.5 5.25h15A2.25 2.25 0 0 1 21.75 7.5v9A2.25 2.25 0 0 1 19.5 18.75h-15A2.25 2.25 0 0 1 2.25 16.5v-9A2.25 2.25 0 0 1 4.5 5.25Z"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6.75 14.25h3"
                    />
                </svg>
            ),
        },
    ];

    return (
        <section className="relative overflow-hidden bg-white py-12 sm:py-14 lg:py-16">
            {/* Background decoration */}
            <div className="pointer-events-none absolute left-1/2 top-0 h-64 w-64 -translate-x-1/2 rounded-full bg-[#EAF3FF] opacity-50 blur-3xl" />

            <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

                {/* =====================================================
                    HEADER
                ====================================================== */}
                <div className="mx-auto mb-9 max-w-2xl text-center">

                    <div className="mb-2 flex items-center justify-center gap-2">
                        <span className="h-[2px] w-6 rounded-full bg-[#FFC928]" />

                        <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#174EA6]">
                            Why Choose Us
                        </span>

                        <span className="h-[2px] w-6 rounded-full bg-[#FFC928]" />
                    </div>

                    <h2 className="text-2xl font-extrabold tracking-tight text-[#0F172A] sm:text-3xl lg:text-[32px]">
                        Why Book With{" "}
                        <span className="text-[#174EA6]">
                            Dubai Hotel Rates?
                        </span>
                    </h2>

                    <p className="mx-auto mt-3 max-w-xl text-sm leading-6 text-slate-500">
                        Everything you need for a simple, secure and
                        hassle-free hotel booking experience in Dubai.
                    </p>
                </div>

                {/* =====================================================
                    BENEFITS
                ====================================================== */}
                <div className="rounded-3xl border border-slate-100 bg-white px-4 py-7 shadow-[0_8px_35px_rgba(15,23,42,0.06)] sm:px-6 lg:px-8 lg:py-8">

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5">

                        {benefits.map((benefit, index) => (
                            <div
                                key={benefit.title}
                                className={`group relative flex flex-col items-center px-5 text-center transition-all duration-300 ${index !== 0
                                        ? "border-slate-200 sm:border-l"
                                        : ""
                                    } ${index === 2
                                        ? "lg:border-l"
                                        : ""
                                    }`}
                            >
                                {/* Icon */}
                                <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#EEF5FF] text-[#174EA6] transition-all duration-300 group-hover:-translate-y-1 group-hover:bg-[#174EA6] group-hover:text-white group-hover:shadow-[0_10px_25px_rgba(23,78,166,0.20)]">
                                    {benefit.icon}
                                </div>

                                {/* Title */}
                                <h3 className="text-sm font-extrabold text-[#0F172A]">
                                    {benefit.title}
                                </h3>

                                {/* Description */}
                                <p className="mt-2 max-w-[180px] text-xs leading-5 text-slate-500">
                                    {benefit.description}
                                </p>

                                {/* Bottom hover accent */}
                                <div className="mt-4 h-[2px] w-0 rounded-full bg-[#FFC928] transition-all duration-300 group-hover:w-8" />
                            </div>
                        ))}

                    </div>
                </div>
            </div>
        </section>
    );
}